<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <b-card>
          <div slot="header">
            <strong>Cấu hình hiển thị</strong>
          </div>
          <br />
          <b-grid
            :searchForm="searchForm"
            :gridOptions="gridOptions"
            selectable
            dataUrl="system/config-display"
            gridName="Danh sách cấu hình hiển thị"
            ref="userTable"
          >
            <template v-slot:actions>
              <router-link
                to="/system/config-display/create"
                tag="button"
                class="btn btn-primary"
                size="md"
              >
                <i class="fa fa-plus"></i>
              </router-link>
              <b-button size="md" @click.stop="deletes" variant="danger">
                <i class="fa fa-trash-o" aria-hidden="true"></i>
              </b-button>
            </template>
            <template v-slot:cell(urlImage)="row">
              <b-button
                size="sm"
                v-b-modal.modalPopover
                @click.stop="showImage(row.item, row.index, $event.target)"
                title="Xem ảnh"
              >
                <i class="fa fa-eye" aria-hidden="true"></i>
              </b-button>
            </template>
            <template v-slot:cell(_actions)="row">
              <b-button-group>
                <b-button
                  v-if="authorize(['ViewConfigDisplay'])"
                  size="sm"
                  :to="{ path: `./detail/${row.item.id}` }"
                  title="xem"
                >
                  <i class="fa fa-eye"></i>
                </b-button>
                <template>
                  <b-button
                    v-if="authorize(['ManageConfigDisplay'])"
                    size="sm"
                    :to="{ path: `./edit/${row.item.id}` }"
                    title="sửa"
                  >
                    <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
                  </b-button>
                  <!-- <b-button
                    v-if="authorize(['ManageConfigDisplay'])"
                    size="sm"
                    :to="{ path: `./${row.item.id}/config` }"
                    title="Cấu hình"
                  >
                  <i class="fa fa-cogs" aria-hidden="true"></i>
                </b-button> -->
                  <!-- <b-button
                    v-if="authorize(['ManageConfigDisplay'])"
                    size="sm"
                    @click.stop="remove(row.item, row.index, $event.target)"
                    class="mr-1"
                    title="xóa"
                  >
                    <i class="fa fa-trash-o" aria-hidden="true"></i>
                  </b-button> -->
                </template>
              </b-button-group>
            </template>
          </b-grid>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { authorizationMixin } from "@/shared/mixins";

export default {
  name: "ListConfigDisplays",
  mixins: [authorizationMixin],
  data() {
    return {
      searchForm: {},
      gridOptions: {
        fields: [
          { key: "name", label: "Tiêu đề", sortable: true },
          {
            key: "categoryName",
            label: "Các danh mục hiển thị",
            sortable: false,
          },
          { key: "numberShow", label: "Số phần tử hiển thị", sortable: true },
          { key: "orderDisplay", label: "Số thứ tự hiển thị", sortable: true },
        ],
        sortBy: null,
      },
    };
  },
  created() {},
  methods: {
    search() {
      this.$refs.userTable.refresh();
    },
    remove(item, index, button) {
      var vm = this;
      if (confirm("Bạn có chắc chắn muốn xóa bản ghi này?")) {
        this.$services.delete(`system/config-display/${item.id}`).done(() => {
          vm.$toastr.s("Xóa bản ghi thành công");
          vm.search();
        });
      }
    },
    deletes() {
      var vm = this;
      var selectedRows = this.$refs.userTable.selectedRows;
      if (selectedRows.length > 0) {
        if (confirm("Bạn có chắc chắn muốn xóa các bản ghi này?")) {
          var data = selectedRows.map((x) => x.id).join(",");
          this.$services
            .delete(`system/config-display?ids=${data}`)
            .done(() => {
              vm.$toastr.s("Xóa bản ghi thành công");
              vm.search();
            });
        }
      } else {
        vm.$toastr.e("Vui lòng chọn người dùng cần xóa");
      }
    },
  },
};
</script>
<style scoped>
</style>
